export function getInitials(name: string) {
  if (!name) return null;
  const [first, last] = name.split(' ');
  return `${first?.[0] || ''}${last?.[0] || ''}`;
}
